import React, { useRef, useState, useEffect } from 'react';
import { Table, Row,Col,Button, Form } from 'react-bootstrap';
import { useReactToPrint } from "react-to-print";

import axios from 'axios';
const config = require('../config.json');


function PrintView(props) {
  const [applicantId, setApplicantId] = React.useState('');
  const { openJobs } = props;

  const [application, setApplication]= useState({applicantName: '', postApplied: '', appliedSchool: '', dob:'',
    jobPostingID:'',applicationID:'', applicationStatus:'', staffID:'', appliedSchoolID:'', appliedPost:'', applicantName:'', 
    dateOfBirth:'', gender:'', emailID:'', phoneNumber:'', religion:'', bloodGroup:'', caste:'', casteName:'',
     communityCertNo:'', ug_subject:'', ug_passingyear:'', ug_university:'', ug_mode:'', ug_percentage:'', ug_class:'', 
     pg_subject:'', pg_passingyear:'', pg_university:'', pg_mode:'', pg_percentage:'', pg_class:'', bed_subject:'',
      bed_passingyear:'', bed_university:'', bed_mode:'', bed_percentage:'', bed_class:'', o_subject:'', o_passingyear:'',
      o_university:'', o_mode:'', o_percentage:'', o_class:'', c_jobStatus:'', p_teachingDetails:'', p_teachingWhere:'', 
      fatherName:'', fatherEducation:'', fatherOccupation:'', fatherIncome:'', motherName:'', motherEducation:'', 
      motherOccupation:'', motherIncome:'', maritalStatus:'', siblinginJesuitSchool:'', parentinJesuitSchool:'', 
      co_activities:'', otherSkills:'', currentAddress:'', permanentAddress:'',cpincode: '',ppincode:'', terms:false
  });
  const [submitted, setSubmitted] = useState(false);
  const [loaded, setLoaded] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchDetails, setSearchDetails] = useState({ emailID: '', dateOfBirth: ''});
  const [searchResults, setSearchResults] = useState([]);
  const [dataAvailable, setDataAvailable] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchValueDOB, setSearchValueDOB] = useState(''); 
  const contentRef = useRef(null);

  // Function to retrieve tapplicantID cookie value
  function getApplicantIdFromCookie() {
    if (typeof document !== 'undefined') {
      const match = document.cookie.match(/(?:^|; )tapplicantID=([^;]*)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
    return '';
  }

  useEffect(() => {
    const id = getApplicantIdFromCookie();
    setApplicantId(id);
  }, [openJobs]);

  const reactToPrintFn = useReactToPrint({ contentRef });

   const handleSearch = async (event) => {
    event.preventDefault();
      try{
          setLoaded(false);
          setDataAvailable(false);
         // const { idToken } = (await fetchAuthSession()).tokens ?? {};
          const clientID='MDUEDN';
          const searchValue = searchDetails.emailID;
          const searchValueDOB = searchDetails.dateOfBirth;
          const searchTopic = 'EmailID';
          await axios.get(`${config.api.invokeURL}/staff/applications?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}&searchDOB=${searchValueDOB}`, {
          headers: {
           // Authorization: idToken,
            'x-api-key':config.api.key
          }
        }).then(async(response) => {
         console.log("response : ", response.data);
          if(response.data.length>0)
          {
              setSearchResults(response.data);
              setApplication(response.data[0]);
              setDataAvailable(true);
              setSearchDetails({ emailID: '', dateOfBirth: '' });
          }
          //enqueueSnackbar(response.data.length + " - Staff's records found!",{variant:'success'}); 
          setLoaded(true);
      }).catch((error)=>{
        //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
      setLoaded(true);
    })
  
      }catch(error){
        //enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
      setLoaded(true);
      }
    }

  return (
    <div>
      {applicantId && (
          <div className='alert alert-info'>Reference Application ID: {applicantId}</div>
        )}

        <h2 className="mb-4 text-center">Enter your Application1 Details to Print</h2>
        <div>
        <Row className="g-3 mb-3">
          <Form.Group as={Col} md="6" controlId="validationFormik01" className="form-floating">
              <Form.Select
                              type="text" name="jobID"
                              value={application.jobPostingID}
                              onChange={event=>setSearchDetails({...searchDetails, emailID: event.target.value})}
                              placeholder="Enter Job ID"
                              autoComplete="given-name"
                            >
                          {openJobs.map((item, index)=>
                          <option key={index} value={item.jobPostingID}>{item.positionApplied} - {item.subject} - {item.jobPostingID}</option>
                            )}                
                            </Form.Select>
              <Form.Label>Enter Job ID :</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="validationFormik01" className="form-floating">
              <Form.Control
                type="text"
                name="emailID"
                value={searchDetails.emailID}
                onChange={event=>setSearchDetails({...searchDetails, emailID: event.target.value})}
                placeholder="Enter Your Email Address"
                autoComplete="given-name"
              />
              <Form.Label>Enter your Registered Email Address:</Form.Label>
            </Form.Group>
             <Form.Group as={Col} md="4" controlId="validationFormik01" className="form-floating">
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={searchDetails.dateOfBirth}
                onChange={event=>setSearchDetails({...searchDetails, dateOfBirth: event.target.value})}
                placeholder="Enter Your Date of Birth"
                autoComplete="given-name"
              />
              <Form.Label>Enter your Date of Birth:</Form.Label>
            </Form.Group>
            <Form.Group as={Col} md="2" controlId="validationFormik01" className="form-floating">
                <Button onClick={event=>handleSearch(event)}>Search</Button>
            </Form.Group>
          </Row>
        </div>
        <p className='alert alert-info'>kindly reachout to Help desk support for queries : Email: support@idntica.com</p>
    {dataAvailable && <div>
      <Button onClick={reactToPrintFn}>Print</Button>
      <div ref={contentRef} className="print-summary-view" style={{maxWidth:'900px', margin:'auto', background:'#fff', padding:'2rem', borderRadius:'12px', boxShadow:'0 2px 12px 0 rgba(44,62,80,0.07)'}}>
      <h2 className="mb-4 text-center">Registration Summary</h2>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Personal Details</h4>
      </div>
      <div className="mb-3"><strong>Post Applied:</strong> {application.appliedPost}</div>
      <div className="mb-3"><strong>School Name:</strong> {application.appliedSchoolID}</div>
      <div className="mb-3"><strong>Name of the Applicant:</strong> {application.applicantName}</div>
      <div className="mb-3"><strong>Date of Birth:</strong> {application.dateOfBirth}</div>
      <div className="mb-3"><strong>Gender:</strong> {application.gender}</div>
      <div className="mb-3"><strong>Email Id:</strong> {application.emailID}</div>
      <div className="mb-3"><strong>Phone Number:</strong> {application.phoneNumber}</div>
      <div className="mb-3"><strong>Religion:</strong> {application.religion}</div>
      <div className="mb-3"><strong>Blood Group:</strong> {application.bloodGroup}</div>
      <div className="mb-3"><strong>Caste:</strong> {application.caste}</div>
      <div className="mb-3"><strong>Caste Name:</strong> {application.casteName}</div>
      <div className="mb-3"><strong>Community Certi. No:</strong> {application.communityCertNo}</div>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Educational Details</h4>
      </div>
      <Table className='table table-bordered'>
        <thead>
          <tr>
            <th>Qualification</th>
            <th>Main Subject</th>
            <th>Year of Passing</th>
            <th>Board / University</th>
            <th>Regular / Corres.</th>
            <th>Percentage</th>
            <th>Class</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>UG</td>
            <td>{application.ug_subject}</td>
            <td>{application.ug_passingyear}</td>
            <td>{application.ug_university}</td>
            <td>{application.ug_mode}</td>
            <td>{application.ug_percentage}</td>
            <td>{application.ug_class}</td>
          </tr>
          <tr>
            <td>PG</td>
            <td>{application.pg_subject}</td>
            <td>{application.pg_passingyear}</td>
            <td>{application.pg_university}</td>
            <td>{application.pg_mode}</td>
            <td>{application.pg_percentage}</td>
            <td>{application.pg_class}</td>
          </tr>
          <tr>
            <td>D.T.Ed</td>
            <td>{application.bed_subject}</td>
            <td>{application.bed_passingyear}</td>
            <td>{application.bed_university}</td>
            <td>{application.bed_mode}</td>
            <td>{application.bed_percentage}</td>
            <td>{application.bed_class}</td>
          </tr>
          <tr>
            <td>Any Other</td>
            <td>{application.o_subject}</td>
            <td>{application.o_passingyear}</td>
            <td>{application.o_university}</td>
            <td>{application.o_mode}</td>
            <td>{application.o_percentage}</td>
            <td>{application.o_class}</td>
          </tr>
        </tbody>
      </Table>
      <div className="section-title mb-3 mt-2" style={{
        background: 'linear-gradient(90deg, #e0e7ef 0%, #f8fafc 60%, #c7d2fe 100%)',
        borderRadius: '12px',
        padding: '12px 0',
        boxShadow: '0 2px 12px 0 rgba(44,62,80,0.07)',
        textAlign: 'center',
        marginBottom: '2rem',
      }}>
        <h4 className="fw-bold" style={{color: '#1a2740', letterSpacing: 1, margin: 0}}>Family Background</h4>
      </div>
      <div className="mb-3"><strong>Father's Name:</strong> {application.fatherName}</div>
      <div className="mb-3"><strong>Father's Education:</strong> {application.fatherEducation}</div>
      <div className="mb-3"><strong>Father's Occupation:</strong> {application.fatherOccupation}</div>
      <div className="mb-3"><strong>Father's Ann. Income:</strong> {application.fatherIncome}</div>
      <div className="mb-3"><strong>Mother's Name:</strong> {application.motherName}</div>
      <div className="mb-3"><strong>Mother's Education:</strong> {application.motherEducation}</div>
      <div className="mb-3"><strong>Mother's Occupation:</strong> {application.motherOccupation}</div>
      <div className="mb-3"><strong>Mother's Ann. Income:</strong> {application.motherIncome}</div>
      <div className="mb-3"><strong>Marital Status:</strong> {application.maritalStatus}</div>
      <div className="mb-3"><strong>Sibling in Jesuit School:</strong> {application.siblinginJesuitSchool}</div>
      <div className="mb-3"><strong>Parent in Jesuit School:</strong> {application.parentinJesuitSchool}</div>
      <div className="mb-3"><strong>Cocurricular Activities:</strong> {application.co_activities}</div>
      <div className="mb-3"><strong>Other Skills:</strong> {application.otherSkills}</div>
      <div className="mb-3"><strong>Current Address:</strong> {application.currentAddress}</div>
      <div className="mb-3"><strong>Permanent Address:</strong> {application.permanentAddress}</div>
      <div className="mb-3"><strong>Communication Pincode:</strong> {application.cpincode}</div>
      <div className="mb-3"><strong>Permanent Pincode:</strong> {application.ppincode}</div>
      <div className="mb-3"><strong>Agreed to Terms:</strong> {application.terms ? 'Yes' : 'No'}</div>
    </div>
            <Button onClick={reactToPrintFn}>Print</Button>
            </div>
}

        </div>

  );         
}

export default PrintView;
